<template>
	<div class="container">
		<div class="content">
			<h2 class="mb_15">{{ $t('merchant.title6') }}</h2>
			<div class="card mb_0">
				<h3 class="title mb_15">{{ $t('merchant.menu_2.menu5') }}</h3>
				<div class="kyc">
					<p class="mb_10">{{ $t('merchant.kyc.text1') }}</p>
					<input type="text" value="1" class="mb_20" readonly />
					<p class="mb_10">{{ $t('merchant.kyc.text2') }}</p>
					<input type="text" value="홍길동" class="mb_20" readonly />
					<p class="mb_10">{{ $t('merchant.kyc.text3') }}</p>
					<input type="text" value="honggd@mail.com" readonly />
				</div>
				<div class="tac mt_15">
					<button class="mr_10">{{ $t('button.delete_account') }}</button>
					<button>{{ $t('button.edit') }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Kyc.m',
};
</script>
